import { useProfileStore } from '../stores/profileStore';
import type { Permission } from '../utils/permissions';

export function useHasPermission(permission: Permission): boolean {
  const permissions = useProfileStore(state => state.permissions);
  return permissions.includes(permission);
}
